// 🔥 프론트엔드 기본 이미지 (public 폴더)
const DEFAULT_IMAGE = '/assets/images/no-image.jpg';

// 🔥 환경별 이미지 URL 처리
export const getImageUrl = (imageUrl, isProfileImage = false) => {
    console.log('🔍 이미지 URL 처리:', imageUrl, '프로필 이미지:', isProfileImage);

    // 빈 값 체크
    if (!imageUrl || imageUrl === 'undefined' || imageUrl === 'null' || imageUrl.trim() === '') {
        return isProfileImage ? null : getDefaultImage(); // 프로필 이미지는 null 반환
    }

    // 이미 완전한 URL인 경우 그대로 반환
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://') || imageUrl.startsWith('data:')) {
        return imageUrl;
    }

    // 백엔드 서버 URL 처리
    const hostname = window.location.hostname;
    const isAdminPage = window.location.pathname.startsWith('/admin');
    let baseUrl;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        // 🔥 로컬에서는 항상 로컬 백엔드 사용
        baseUrl = 'http://localhost:8080';
    } else if (hostname === '13.125.214.191') {
        // 운영서버에서는 백엔드 API 포트 사용
        baseUrl = 'http://13.125.214.191:8080';
    } else if (hostname.includes('doctormarket.co.kr')) {
        // 🔥 co.kr 접속자는 co.kr 기준으로 이미지 로드 (같은 도메인 유지)
        if (isAdminPage) {
            baseUrl = 'http://13.125.214.191:8080';
        } else {
            baseUrl = 'https://doctormarket.co.kr';
        }
    } else if (hostname.includes('doctormarket.kr')) {
        if (isAdminPage) {
            baseUrl = 'http://13.125.214.191:8080';
        } else {
            baseUrl = 'https://doctormarket.kr';
        }
    } else {
        // 기타 환경에서도 관리자 페이지는 EC2 API 포트 사용
        if (isAdminPage) {
            baseUrl = 'http://13.125.214.191:8080';
        } else {
            baseUrl = 'http://13.125.214.191:8080';
        }
    }

    // 상대 경로를 절대 URL로 변환
    return imageUrl.startsWith('/') ? baseUrl + imageUrl : baseUrl + '/' + imageUrl;
};

// 🔥 기본 이미지 반환
export const getDefaultImage = () => {
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return DEFAULT_IMAGE;
    } else {
        // 운영서버에서는 현재 도메인 기준으로 기본 이미지 제공
        return window.location.origin + DEFAULT_IMAGE;
    }
};

// 🔥 이미지 로드 실패 시 처리 함수
export const handleImageError = (event) => {
    const img = event.target;
    const defaultImageUrl = getDefaultImage();

    if (img.src !== defaultImageUrl) {
        img.src = defaultImageUrl;
        img.onerror = null; // 무한 루프 방지
        console.log('�� 이미지 로드 실패, 기본 이미지로 교체:', img.src);
    }
};

// 🔥 업로드 URL 생성 함수 추가
export const getUploadUrl = (endpoint = '/api/admin/upload') => {
    const hostname = window.location.hostname;
    const isAdminPage = window.location.pathname.startsWith('/admin');
    let baseUrl;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        baseUrl = 'http://localhost:8080';
    } else if (hostname === '13.125.214.191') {
        baseUrl = 'http://13.125.214.191:8080';
    } else if (hostname.includes('doctormarket.co.kr')) {
        // 🔥 co.kr 접속자는 co.kr 기준으로 이미지 로드 (같은 도메인 유지)
        if (isAdminPage) {
            baseUrl = 'http://13.125.214.191:8080';
        } else {
            baseUrl = 'https://doctormarket.co.kr';
        }
    } else if (hostname.includes('doctormarket.kr')) {
        if (isAdminPage) {
            baseUrl = 'http://13.125.214.191:8080';
        } else {
            baseUrl = 'https://doctormarket.kr';
        }
    } else {
        if (isAdminPage) {
            baseUrl = 'http://13.125.214.191:8080';
        } else {
            baseUrl = 'http://13.125.214.191:8080';
        }
    }

    return `${baseUrl}${endpoint}`;
};

// 🔥 모든 img 태그에 자동 오류 처리 추가
export const setupImageErrorHandling = () => {
    // 기존 이미지들 처리
    const images = document.querySelectorAll('img');
    images.forEach(img => {
        if (!img.hasAttribute('data-error-handled')) {
            img.addEventListener('error', handleImageError);
            img.setAttribute('data-error-handled', 'true');
        }
    });

    // 새로 추가되는 이미지들 자동 처리 (MutationObserver)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element 노드
                    // 직접 img 태그인 경우
                    if (node.tagName === 'IMG' && !node.hasAttribute('data-error-handled')) {
                        node.addEventListener('error', handleImageError);
                        node.setAttribute('data-error-handled', 'true');
                    }
                    // 하위에 img 태그가 있는 경우
                    const imgs = node.querySelectorAll ? node.querySelectorAll('img') : [];
                    imgs.forEach(img => {
                        if (!img.hasAttribute('data-error-handled')) {
                            img.addEventListener('error', handleImageError);
                            img.setAttribute('data-error-handled', 'true');
                        }
                    });
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    console.log('✅ 이미지 자동 오류 처리 설정 완료');
};